/**
 * Where the event form sits: on the calendar's purple modal (`dark`, its historical look, the
 * default), or on a white card of the assistant's chat (`light`). One form, two looks: the fields,
 * the rules and the save are the same; only these classes change.
 */
export type EventFormTone = "dark" | "light";

type ToneClasses = {
    /** Border of a field (input, picker, toolbar, editor). */
    border: string;
    placeholder: string;
    /** The icon that names a row. */
    icon: string;
    /** A toolbar button, hovered and active. */
    toolHover: string;
    toolActive: string;
    /** An attendee's chip, and its remove cross. */
    chip: string;
    chipRemove: string;
    checkbox: string;
};

export const eventFormTone: Record<EventFormTone, ToneClasses> = {
    dark: {
        border: "border-white/30",
        placeholder: "placeholder:text-white/70",
        icon: "",
        toolHover: "hover:bg-white/60",
        toolActive: "bg-white/30",
        chip: "bg-primary-dark text-white",
        chipRemove: "text-gray-500",
        checkbox:
            "bg-primary-dark data-[state=checked]:bg-primary-dark data-[state=checked]:text-white",
    },
    light: {
        border: "border-assistant-border",
        placeholder: "placeholder:text-neutral-base",
        icon: "text-neutral-dark",
        toolHover: "hover:bg-primary-lightest",
        toolActive: "bg-primary-lightest",
        chip: "bg-primary-lightest text-primary-darker",
        chipRemove: "text-neutral-dark",
        checkbox:
            "border-assistant-borderStrong bg-white data-[state=checked]:border-primary-dark data-[state=checked]:bg-primary-dark data-[state=checked]:text-white",
    },
};
